import { memo } from 'react';
import { DeleteIcon } from 'assets/icons';
import { useSelector, useDispatch } from 'react-redux';
import { generalActions } from 'store/actions';
import * as S from './SelectedApps.styled';
import { ParagraphWithTooltip, IconButton, Label } from 'components';

const SelectedItem = (props) => {
  const showAppName = useSelector((state) => state.auth.show_app_name);
  const { pba_number, pba_name } = props;

  const dispatch = useDispatch();

  const handleClickBtnX = () => {
    dispatch(generalActions.delete_currently_selected_app(pba_number));
  };

  return (
    <S.SelectedItem>
      <S.FlexRow2>
        <S.Label10>
          <ParagraphWithTooltip
            text={showAppName ? pba_name ?? '' : `App ID: ${pba_number ?? ''}`}
          />
          {showAppName && (
            <div style={{ display: 'flex' }}>
              <Label variant='description' text='App ID:' />
              <ParagraphWithTooltip text={pba_number.toString()} />
            </div>
          )}
        </S.Label10>
      </S.FlexRow2>
      <IconButton.SmallSize
        isDefaultMuted
        icon={DeleteIcon}
        type={IconButton.btnTypes.tertiary}
        onClick={handleClickBtnX}
      />
    </S.SelectedItem>
  );
};

export default memo(SelectedItem);
